import * as React from 'react'

interface IBadgeProps {
  label: string
}

class Badge extends React.Component<IBadgeProps, any> {
  public render() {
    return <span className='h6 border-grey p02 border-radius mr1'>{this.props.label}</span>
  }
}

export default Badge



// WEBPACK FOOTER //
// ./src/components/ui/Badge.tsx